export enum CreditCardTypeEnum {
  Visa = 'Visa',
  Mastercard = 'Mastercard',
  Discover = 'Discover',
  AmericanExpress = 'American Express',
}

export const CREDIT_CARD_TYPE_OPTIONS = Object.entries(CreditCardTypeEnum).map(([key, label]) => ({
  label: label,
  value: key,
}));

export enum PaymentTypeEnum {
  DownPayment = 'Down Payment',
  FundingOverage = 'Funding Overage',
  TitleFees = 'Title Fees',
}

export const PAYMENT_TYPE_OPTIONS = Object.entries(PaymentTypeEnum).map(([key, label]) => ({
  label: label,
  value: key,
}));

export enum CreditCardPaymentProcessStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}

export const CREDIT_CARD_PAYMENT_PROCESS_STATUSES_OPTIONS = [
  {
    label: CreditCardPaymentProcessStatusEnum.PENDING,
    value: CreditCardPaymentProcessStatusEnum.PENDING,
  },
  {
    label: CreditCardPaymentProcessStatusEnum.APPROVED,
    value: CreditCardPaymentProcessStatusEnum.APPROVED,
  },
  {
    label: CreditCardPaymentProcessStatusEnum.DECLINED,
    value: CreditCardPaymentProcessStatusEnum.DECLINED,
  },
];

export interface Card {
  downPaymentId: string;
  contactCreditCardId: string;
  creditCardType: CreditCardTypeEnum | null;
  holderName: string;
  lastFourDigits: string;
  expiryDate: Date | null;
  cvv: string | null;
  amount: number | null;
  processingDate: Date | null;
  processedDate: Date | null;
  processingStatus: CreditCardPaymentProcessStatusEnum | null;
  notes: string;
  index: number;
  isActive: boolean;
  isCopied: boolean;
  paymentType: keyof typeof PaymentTypeEnum | null;
}

export interface ICopyCard {
  contactId: string;
  dealId: string;
  downPaymentOnDeal: number;
  contactCreditCardId: string;
  amount: number | null;
  processingDate: Date | null;
  notes: string;
  isActive: boolean;
  paymentType: keyof typeof PaymentTypeEnum | null;
}

export interface Group {
  disabled: boolean;
  name: string | null;
}

export interface CreditCardType {
  disabled: boolean;
  group: Group;
  selected: boolean;
  text: string;
  value: string;
}

export interface ICardsResponse {
  getCardModels: Card[];
  dealId: string | null;
  contactId: string | null;
  creditCardTypes: CreditCardType[] | null;
  errors: string[] | null;
  amount: number;
}

export interface ICardFormData
  extends Pick<
    Card,
    | 'holderName'
    | 'processingDate'
    | 'processedDate'
    | 'processingStatus'
    | 'cvv'
    | 'amount'
    | 'creditCardType'
    | 'paymentType'
    | 'notes'
    | 'expiryDate'
  > {
  downPaymentId?: string;
  cardNumber: string;
}

export type IUpdateCardFormData = Pick<ICardFormData, 'holderName' | 'cardNumber' | 'cvv' | 'expiryDate' | 'creditCardType'>;

export type IConfirmationProcessData = Pick<ICardFormData, 'holderName' | 'cardNumber' | 'amount'>;
